"use client"

import { usePathname } from "next/navigation";

const NavbarItem = (props: any) => {
    return (
        <a href={props.url} className={(usePathname() == props.url) ? "active" : ""}>
            {props.icon}
            {props.title}
        </a>
    );
};

export default NavbarItem